export default {
  "banner-members": () => import("/vercel/path0/src/applications/rolfsbuss-web/layouts/banner-members.vue"),
  "map-layout": () => import("/vercel/path0/src/applications/rolfsbuss-web/layouts/map-layout.vue"),
  "banner-default": () => import("/vercel/path0/src/layers/web/layouts/banner-default.vue"),
  "banner-trip": () => import("/vercel/path0/src/layers/web/layouts/banner-trip.vue"),
  default: () => import("/vercel/path0/src/layers/web/layouts/default.vue"),
  "noheader-layout": () => import("/vercel/path0/src/layers/web/layouts/noheader-layout.vue")
}